import { createApp } from 'vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
export default (app: ReturnType<typeof createApp>) => {
  app.use(autoAnimatePlugin)
}
